































































































import { defineComponent, onMounted, ref, computed } from '@vue/composition-api'
import { useReflectiveInjector } from '@zhfe/vue2-di-plugin'

import { VideoUserInfoService } from './video-userInfo.service'
import { UserService } from '@/services/user.service'
import { PERMISSION_VIP_TYPE } from '@/config/dataMap'
import { dateFilter } from '@/filters'
import store from '@/store'

export default defineComponent({
  name: 'VideoUserInfo',

  setup (props, context) {
    const injector = useReflectiveInjector([VideoUserInfoService])
    const video = injector.get(VideoUserInfoService)
    const user = injector.get(UserService)

    // 是否终身会员 - PDF终身会员 | 视频终身会员
    const isLifeMember = computed(() => user.isPdfLifeMember || user.isVideoLifeMember)
    // 是否普通会员 - 毒霸普通会员 | PDF普通会员 | 视频普通会员
    const isGeneralMember = computed(() => user.isMember || user.isPdfMember || user.isVideoMember)
    // 是否钻石会员
    const isDiamondMember = computed(() => user.isDiamondMember)

    const userInfo = computed(() => user.userInfo)
    const loginStatus = computed(() => user.loginStatus)
    const avatar = computed(() => user.avatarUrl)
    const badgeClass = computed(() => (isGeneralMember ? 'sprite-icon sprite-icon-badge-vip' : ''))

    // 获取会员过期时间
    const getExpireDate = () => {
      if (user.isMember) {
        return dateFilter(user.userInfo.vip_ex_date)
      } else if (user.isPdfMember) {
        return dateFilter(store.getters.pdfPermissionVipInfo.vip_ex_date)
      } else if (user.isVideoMember) {
        return dateFilter(user.getPermissionVipInfoItem(PERMISSION_VIP_TYPE.videoVip)?.vip_ex_date)
      }
    }

    onMounted(() => {
      if (user.loginStatus) {
        user.refresh()
      }
    })

    function login (type:number) {
      if (user.loginStatus) {
        return false
      }
      video.openLoginWindow()

      if (type) {
        video.report(type, loginStatus ? 1 : 2)
      }
    }

    function logout (op?:number) {
      user.setLoginStatus(0)
      op && video.logout()
      user.onLogout.next()

      if (op === 2) {
        video.report(3, loginStatus ? 1 : 2)
      }
    }

    function showPay (tab:number) {
      video.report(11, loginStatus ? 1 : 2)
      context.emit('showPay')
      user.onShowPay.next(tab)
    }

    function changeUserInfo () {
      if (!user.loginStatus) {
        login(1)
        return false
      }
      video.report(56, loginStatus ? 1 : 2)
      context.emit('showChangeUserInfoPop')
    }

    return {
      badgeClass,
      login,
      showPay,
      changeUserInfo,
      logout,
      userInfo,
      loginStatus,
      avatar,
      devicePixelRatio: window.devicePixelRatio,

      isLifeMember,
      isGeneralMember,
      isDiamondMember,
      getExpireDate
    }
  }

})
